import HuddleBoard from './HuddleBoard';
export default HuddleBoard;